// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3yv6U","content":"styles_content__yo_H8","checkbox":"styles_checkbox__3Ha-v","checkboxLabel":"styles_checkboxLabel__QpeBh"};